import { memo } from "react";
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";

/** Napomena stavke u podretku — prikazuje se samo kad stavka ima napomenu. */
const InvoiceIncomingItemRowChild: React.FC<TableRowChildProps> = (props) => {
  const { index, row } = props;

  return (
    <tr key={index} className="bg-amber-50 text-slate-900">
      <td className="text-sm w-full" colSpan={12}>
        <div className="flex items-center p-3">{row.note}</div>
      </td>
    </tr>
  );
};

export default memo(InvoiceIncomingItemRowChild);
